import React, { useEffect, useState } from "react";
import { HttpStatusCode } from "axios";
import clsx from "clsx";

import { useUserContext } from "../../contexts/userContext";

import {
  ServiceGroupCategoryType,
  ServiceGroupItem,
  getBuildingList,
} from "../../services/userServiceServices";
import CommonSelect, { SelectOption } from "../../components/Select";
import SimplePopup from "../../components/Popup/Simple";
import { TalkFindBuildingDownArrow } from "../../pages/Talk";

type Props = {
  categoryCode: ServiceGroupCategoryType;
  className?: string;
  useAllOption?: boolean;
};

export default function useServiceGroupBuilding({
  categoryCode,
  className,
  useAllOption = false,
}: Props): [ServiceGroupItem | undefined, JSX.Element] {
  const [user] = useUserContext();
  const [optionList, setOptionList] = useState<ServiceGroupItem[]>([]);
  const [selectedBuilding, setSelectedBuilding] = useState<
    ServiceGroupItem | undefined
  >(
    useAllOption
      ? undefined
      : ({
          buildingId: user.buildingId,
          buildingName: user.building?.buildingName,
        } as ServiceGroupItem)
  );
  const [popup, setPopup] = useState("");
  const [message, setMessage] = useState("");
  useEffect(() => {
    getBuildingList({
      buildingId: user?.buildingId ?? "",
      categoryCode,
    }).then((res) => {
      if (res.status === HttpStatusCode.Ok) {
        setOptionList(res.data);
        if (
          res.data.length > 0 &&
          !selectedBuilding?.buildingId &&
          !useAllOption
        ) {
          setSelectedBuilding(res.data[0]);
        }
      }
    });
  }, [user.buildingId]);

  return [
    selectedBuilding,
    <div className={clsx(["w-fit max-w-[calc(100vw-40px)]", className])}>
      <CommonSelect
        value={selectedBuilding?.buildingId ?? "all"}
        optionList={[
          ...(useAllOption
            ? [
                {
                  value: "all",
                  label: "전체",
                } as SelectOption,
              ]
            : []),
          {
            value: user.buildingId,
            label: user.buildingName,
          } as SelectOption,
          ...optionList
            .filter((item) => item.buildingId !== user.buildingId)
            .map((item) => ({
              value: item.buildingId,
              label: item.buildingName,
            })),
        ]}
        onChange={(value) => {
          const selectedBuildingInfo = optionList.find(
            (item) => item.buildingId === value.value
          );
          if (selectedBuildingInfo) {
            setSelectedBuilding(selectedBuildingInfo);
          } else {
            setSelectedBuilding(undefined);
          }
        }}
        unUsePadding
        arrowIcon={<TalkFindBuildingDownArrow />}
        onClick={() => {
          if (optionList.length === 0) {
            setPopup("error");
            setMessage("연결된 서비스 건물이 없습니다.");
            return;
          }
        }}
        optionOrder="between"
        variant="selectBuilding"
        optionWidth="240px"
        useTruncate
        labelClassName="max-w-[calc(100vw-100px)]"
      />

      <SimplePopup
        isOpen={"error" === popup}
        onClose={() => setPopup("")}
        message={message}
      />
    </div>,
  ];
}
